<app-title-bar rootBreadCrumbs="['i18n.core.navigation.import-configuration']"
  titleText="i18n.core.navigation.import-configuration-protocol"></app-title-bar>
<div class="row">
  <div class="col-12">
    <button class="btn btn-primary float-end mb-2 refresh-btn" (click)="onRefresh()">
      <span class="e-icons icon-reset"></span>
    </button>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <ejs-grid #grid rowHeight="38" class="grid-with-toolbar grid-configuration" [dataSource]="data"
      [allowSorting]="true" [allowPaging]="true" [pageSettings]='pageSettings' [allowFiltering]="true"
      [filterSettings]="filterSettings" [editSettings]='editSettings' (dataBound)="onDataBound()"
      (rowDataBound)="rowDataBound($event)" (actionComplete)="actionComplete($event)"
      (actionBegin)="actionBegin($event)" (commandClick)="commandClick($event)"
      (recordDoubleClick)="onRecordDoubleClick($event)">
      <e-columns>
        <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
        <e-column field="createdOn" type="date" [filter]="dateFilter"
          headerText="{{'i18n.domain.import-protocol.timestamp' | translate}}" clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            {{data.createdOn | date:'dd.MM.yyyy HH:mm:ss'}}
          </ng-template>
        </e-column>
        <e-column field="client.name" headerText="{{'i18n.shared.fields.client' | translate}}"
          clipMode="EllipsisWithTooltip"></e-column>
        <e-column field="sourceInfo" headerText="{{'i18n.domain.import-protocol.imported-by' | translate}}"
          clipMode="EllipsisWithTooltip"></e-column>
        <e-column field="configurationName" headerText="{{'i18n.domain.import-protocol.configuration' | translate}}"
          clipMode="EllipsisWithTooltip"></e-column>
        <e-column field="navisionImportTemplate" headerText="{{'i18n.domain.import-protocol.navision-import-template' | translate}}"
          clipMode="EllipsisWithTooltip" [filter]="checkBoxFilter" [allowSorting]='false'>
          <ng-template #filterItemTemplate let-data>{{formatFilterNavisionImportTemplate(data)}}</ng-template>
          <ng-template #template let-data>
            {{'i18n.domain.import-configuration.enums.navision-import-template.' + NavisionImportTemplate[data.navisionImportTemplate] | translate}}
          </ng-template>
        </e-column>

        <e-column field="successState" headerText="{{'i18n.domain.import-protocol.state' | translate}}"
          clipMode="EllipsisWithTooltip" [filter]="successStateFilter">
          <ng-template #filterItemTemplate let-data>
            {{'i18n.domain.import-configuration.enums.success-state.' + SuccessState[data.successState] | translate}}
          </ng-template>
          <ng-template #template let-data>
            {{'i18n.domain.import-configuration.enums.success-state.' + SuccessState[data.successState] | translate}}
          </ng-template>
        </e-column>
        <e-column field="lastState" headerText="{{'i18n.domain.import-protocol.entry-state' | translate}}"
          clipMode="EllipsisWithTooltip" [filter]="successStateFilter">
          <ng-template #filterItemTemplate let-data>
            {{'i18n.domain.import-configuration.enums.import-entry-status.' + EntryState[data.lastState] | translate}}
          </ng-template>
          <ng-template #template let-data>
            {{'i18n.domain.import-configuration.enums.import-entry-status.' + EntryState[data.lastState] | translate}}
          </ng-template>
        </e-column>
        <e-column field="lastErrorMessage"
          headerText="{{'i18n.domain.import-protocol.last-error-message' | translate}}">
          <ng-template #template let-data>
            <ejs-tooltip id="tooltipClick" opensOn='Click' [isSticky]='true' width="600px">
              <ng-template #content>
                <div [innerHTML]="extractJsonMessage(data.lastErrorMessage, false, 0)">
                </div>
              </ng-template>
              <div>
                {{extractJsonMessage(data.lastErrorMessage, true, 200)}}
              </div>
            </ejs-tooltip>
          </ng-template>

        </e-column>
        <e-column headerText="" [commands]='gridCommands' width="100" textAlign="Center"></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
<ejs-dialog #logEntryDialog [isModal]="true" cssClass="logEntry" [showCloseIcon]="true" [visible]="false"
  (close)="onClose()">
  <ng-template #header>
    {{'i18n.domain.import-protocol.titleEdit' | translate}}
  </ng-template>

  <ng-template #content>
    <app-import-configuration-protocol-edit-form [protocol]="protocol"></app-import-configuration-protocol-edit-form>
  </ng-template>

  <ng-template #footerTemplate>
    <button class="btn btn-outline-secondary me-2" (click)="onClose()">{{'i18n.shared.close' | translate}}</button>
    @if(hasError){
      <button class="btn btn-danger" (click)="onSetAsFixed()">{{'i18n.domain.import-protocol.setAsFixed' | translate}}</button>
    }
  </ng-template>
</ejs-dialog>
